module.exports = __webpack_public_path__ + "img/CARAC1.ddb0c9be.jpg";